



















































import Vue from 'vue';
import { Form } from 'element-ui'

interface FileExtractData {
  isShow: boolean,
  form: {
      thatDegreeDate: string
  },
  rules: {
      thatDegreeDate: any[]
  },
  pickerOption: any
}


export default Vue.extend({
  name: 'BatchImport',
  props: ['fileExtract', 'degreeDate'],
  data(): FileExtractData {
    return {
        isShow: false,
        form: {
            thatDegreeDate: '',
        },
        rules: {
            thatDegreeDate: [
              { 
                  validator: (rule: any, value: string, callback: (error: Error | void) => void) => {
                      if (!value) {
                          this.$message.error('请填写该批送检论文学位授予时间');
                          callback(new Error(''));
                      } else if (new Date(value) > new Date()) {
                          callback(new Error('不能选择未发生的日期'));
                      } else {
                          callback();
                      }
                  }, 
                  trigger: 'blur'
              }
            ]
        },
        pickerOption: {
          disabledDate(time: Date) {
              return time.getTime() > Date.now();
          }
        },
    };
  },
  watch: {
      fileExtract(val) {
          this.isShow = val;
      },
      degreeDate: {
          immediate: true,
          handler(val) {
              this.form.thatDegreeDate = val;
          }
      }
  },
  computed: {
      
  },
  methods: {
      handleClose() {
          this.$emit('update:fileExtract', false);
      },
      handleDegreeDate() {
          this.$emit('update:degreeDate', this.form.thatDegreeDate);
      },
      handleConfirm() {
          (this.$refs.degreeDateForm as Form).validate((valid) => {
              if (valid) {
                  this.$emit('update:fileExtract', false);
                  this.updateStorage();
              } else {
                  return false;
              }
          });
      },
      updateStorage() {
          let uploadSet = localStorage.getItem('uploadSet');
          if(uploadSet) {
              let temp = JSON.parse(uploadSet);
              temp.degreeDate = this.form.thatDegreeDate;
              localStorage.setItem('uploadSet',JSON.stringify(temp));
          } else {
              localStorage.setItem('uploadSet',JSON.stringify({
                  degreeDate: this.form.thatDegreeDate
              }));
          }
      }
  },
  mounted() {
    
  }
});
